module.exports = __webpack_public_path__ + "img/digital2.9a6a39df.png";